import { notificationService } from '../../../../services/notificationService';
import { useFormContext, useWatch } from 'react-hook-form';
import { EpStepContent, EpStepSelect } from '../../components';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { useEffect } from 'react';

export default function NotificationOptionInput({
  translations,
}: {
  translations: unknown;
}) {
  const { setValue } = useFormContext();
  const NotificationIncident = useWatch({
    name: 'notificationIncidentId.inputValue',
  });
  const { getNotificationIncidentsOptions } = notificationService;
  const { data: OptionOptions } =
    getNotificationIncidentsOptions(NotificationIncident);

  useEffect(() => {
    const isCategoryIncidentSelectedAndHasNoOptions =
      NotificationIncident && !OptionOptions;

    if (isCategoryIncidentSelectedAndHasNoOptions) {
      setValue('notificationOptionId', undefined);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [NotificationIncident, OptionOptions]);

  if (OptionOptions?.itens && OptionOptions?.itens.length > 0) {
    return (
      <EpStepContent.Label label={`${t(translations, 'Incident options')} *`}>
        <EpStepSelect
          data={OptionOptions?.itens}
          errorMessage={t(translations, '* Required Fied')}
          registerId={'notificationOptionId'}
        />
      </EpStepContent.Label>
    );
  }

  return null;
}
